import {
  trigger,
  transition,
  style,
  query,
  animate,
  group,
  AnimationMetadata
} from '@angular/animations';

/**
 * Enterprise route transitions.
 *
 * Bound to routed content only. Header, footer, and global shell stay outside
 * this trigger so navigation feels stable.
 */

const TIMING_LEAVE = '220ms cubic-bezier(0.4, 0, 1, 1)';
const TIMING_ENTER = '320ms cubic-bezier(0, 0, 0.2, 1)';

const optionalQuery = (selector: string, anim: AnimationMetadata[]) =>
  query(selector, anim, { optional: true });

const routedViews = [
  style({
    top: 0,
    left: 0,
    width: '100%'
  })
];

const slideTransition = (enterX: string, leaveX: string): AnimationMetadata[] => [
  style({ position: 'relative', overflow: 'hidden' }),
  optionalQuery(':enter, :leave', routedViews),
  optionalQuery(':leave', [
    style({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 1
    })
  ]),
  optionalQuery(':enter', [
    style({
      opacity: 0,
      transform: `translate3d(${enterX}, 0, 0)`,
      zIndex: 2
    })
  ]),
  group([
    optionalQuery(':leave', [
      animate(TIMING_LEAVE, style({
        opacity: 0,
        transform: `translate3d(${leaveX}, 0, 0)`
      }))
    ]),
    optionalQuery(':enter', [
      animate(TIMING_ENTER, style({
        opacity: 1,
        transform: 'translate3d(0, 0, 0)'
      }))
    ])
  ])
];

export const routeTransitionAnimations = trigger('routeAnimations', [
  transition(':increment', slideTransition('32px', '-18px')),
  transition(':decrement', slideTransition('-32px', '18px')),
  transition('* <=> *', [
    style({ position: 'relative', overflow: 'hidden' }),
    optionalQuery(':leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%'
      })
    ]),
    optionalQuery(':enter', [
      style({ opacity: 0, transform: 'scale(0.98)' })
    ]),
    group([
      optionalQuery(':leave', [
        animate(TIMING_LEAVE, style({ opacity: 0, transform: 'scale(0.99)' }))
      ]),
      optionalQuery(':enter', [
        animate(TIMING_ENTER, style({ opacity: 1, transform: 'scale(1)' }))
      ])
    ])
  ])
]);
